import React from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import type { TooltipContentProps } from '@radix-ui/react-tooltip';

import defaultIconToggled from '@images/icons/tooltip/tipIcon.svg';
import defaultIcon from '@images/icons/tooltip/tipIconDefault.svg';

import './Tooltip.css';

interface TooltipButtonArgs {
  text: string;
  onClick?: () => void;
  icon?: string;
  toggledIcon?: string;
  side?: TooltipContentProps['side'];
  sideOffset?: TooltipContentProps['sideOffset'];
  customIconSize?: number;
}

export function TooltipButton({
  text,
  onClick,
  icon = defaultIcon,
  toggledIcon = defaultIconToggled,
  side = 'bottom',
  sideOffset = 0,
  customIconSize = 16,
}: TooltipButtonArgs) {
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);

  const handleTooltipClick = () => {
    if (!onClick) {
      return;
    }

    onClick();
  };

  const handleToggleTooltip = (tooltipState: boolean) => {
    setIsTooltipOpen(tooltipState);
  };

  return (
    <Tooltip.Provider>
      <Tooltip.Root open={isTooltipOpen}>
        <Tooltip.Trigger
          asChild
          onMouseEnter={() => handleToggleTooltip(true)}
          onMouseLeave={() => handleToggleTooltip(false)}
          onFocus={() => handleToggleTooltip(true)}
          onBlur={() => handleToggleTooltip(false)}
        >
          <button type="button" className="IconButton" onClick={handleTooltipClick}>
            <img
              alt="Иконка"
              src={isTooltipOpen && !!toggledIcon ? toggledIcon : icon}
              style={{ width: `${customIconSize}px`, height: `${customIconSize}px` }}
            />
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content className="TooltipContent" sideOffset={sideOffset} side={side}>
            {text}
            <Tooltip.Arrow className="TooltipArrow" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
